var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.importType === 1
      ? _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "importDataForm",
                attrs: {
                  model: _vm.importDataParam,
                  size: "small",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newOrder.waybillNumber") + "：",
                      prop: "waybillNumbers",
                      rules: {
                        required: true,
                        message: this.$t("GlobalSetObj.inputWaybillNumber"),
                        trigger: ["blur", "change"],
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t(
                          "GlobalSetObj.CanBeEnteredMultiple2000"
                        ),
                        type: "textarea",
                        rows: 4,
                      },
                      model: {
                        value: _vm.importDataParam.waybillNumbers,
                        callback: function ($$v) {
                          _vm.$set(_vm.importDataParam, "waybillNumbers", $$v)
                        },
                        expression: "importDataParam.waybillNumbers",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("newOrder.LossType") + "：",
                      prop: "lossType",
                      rules: {
                        required: true,
                        message: this.$t("GlobalSetObj.pleaseChoose"),
                        trigger: ["blur", "change"],
                      },
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.importDataParam.lossType,
                          callback: function ($$v) {
                            _vm.$set(_vm.importDataParam, "lossType", $$v)
                          },
                          expression: "importDataParam.lossType",
                        },
                      },
                      _vm._l(
                        _vm.responsibilityTypeList.loss_type,
                        function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: {
                              label: item.value,
                              value: Number(item.key),
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("fixDutyFine.ResponsibleBranch") + "：",
                      prop: "siteId",
                      rules: {
                        required: true,
                        message: this.$t("GlobalSetObj.pleaseChoose"),
                        trigger: ["blur", "change"],
                      },
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: this.$t("GlobalSetObj.pleaseChoose"),
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.importDataParam.siteId,
                          callback: function ($$v) {
                            _vm.$set(_vm.importDataParam, "siteId", $$v)
                          },
                          expression: "importDataParam.siteId",
                        },
                      },
                      _vm._l(_vm.siteIdList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", [
          _c("span", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v(
              _vm._s(_vm.$t("receivablePayable.TotalImport")) +
                "：" +
                _vm._s(_vm.importData.totalCount)
            ),
          ]),
          _c("span", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v(
              _vm._s(_vm.$t("orderCenterCont.ImportWasSuccessful")) +
                "：" +
                _vm._s(_vm.importData.success)
            ),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("orderCenterCont.ImportFailed")) + "："),
            _c("span", { staticStyle: { color: "#DD4A68" } }, [
              _vm._v(_vm._s(_vm.importData.fail)),
            ]),
          ]),
          _vm.importData.fail > 0
            ? _c("div", [
                _c("div", { staticStyle: { margin: "10px 0" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("fixDutyFine.ImportFailedOrderNumber")) +
                      "： "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "300px",
                      "overflow-y": "auto",
                    },
                  },
                  _vm._l(_vm.importData.failList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { "margin-bottom": "5px" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(index + 1) +
                            "." +
                            _vm._s(item.waybillNumber) +
                            "，" +
                            _vm._s(item.reason) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }